<script>
  import { e, f, o, r, more} from './stores.js';
</script>

<div class="metaphors" class:hide="{!$more}">
  <div class="metaphor">
    <div class="explain">Retrieval is to obsolescence as enhancement is to reversal</div>
    <div class="actual">{$r} is to {$o} as {$e} is to {$f}</div>
  </div>

  <div class="metaphor">
    <div class="explain">Retrieval is to enhancement as obsolescence is to reversal</div>
    <div class="actual">{$r} is to {$e} as {$o} is to {$f}</div>
  </div>
</div>





<style>
  .metaphors {text-align: center; margin: 1rem 1rem;}
  .metaphor {margin: 1rem 1rem;}
  .actual {font-weight: bold;}
  .hide {display: none;}
</style>